import { fg } from '@atlassian/jira-feature-gating';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { GetTeamsBulkResponse } from './types.tsx';

const TEAMS_BULK_REST_API_URL_V3 = '/gateway/api/v3/teams/withMembers/bulk';
const TEAMS_BULK_REST_API_URL_V4 = '/gateway/api/v4/teams/withMembers/bulk';

export const getTeams = async (teamIds: string[], siteId: String) =>
	fg('bulk_team_fetch_to_use_legion_v4_apis')
		? performPostRequest<GetTeamsBulkResponse>(TEAMS_BULK_REST_API_URL_V4, {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					teamIds,
					siteId,
				}),
			})
		: performPostRequest<GetTeamsBulkResponse>(TEAMS_BULK_REST_API_URL_V3, {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(teamIds),
			});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { TeamRecord } from './types';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mockGetTeamsSuccess, mockGetTeamsFailure } from './mocks';
